import { useAuth } from "../context/AuthContext";

const ERROR_MESSAGES = {
  not_authorized: {
    title: "אין לך הרשאה למערכת",
    body:  "המשתמש אינו מוגדר כטכנאי במערכת. פנה למנהל המערכת להוספתך.",
  },
  domain: {
    title: "דומיין לא מורשה",
    body:  "כניסה מותרת רק לחשבונות prodigy.co.il.",
  },
  server_unavailable: {
    title: "השרת אינו זמין כרגע",
    body:  "לא ניתן היה לטעון את פרטי המשתמש. ההתחברות נשמרה: טען את הדף מחדש בעוד רגע.",
  },
  inactive: {
    title: "החשבון מושבת",
    body:  "חשבון זה הושבת במערכת. פנה למנהל המערכת.",
  },
  error: {
    title: "שגיאה בהתחברות",
    body:  "אירעה שגיאה בלתי צפויה. נסה שוב.",
  },
};

export default function LoginPage() {
  const { login, authError } = useAuth();
  // an unknown code (a Microsoft-side error such as access_denied / interaction_required is stored as-is) used to
  // show NO message at all
  const err = authError ? (ERROR_MESSAGES[authError] || ERROR_MESSAGES.error) : null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-700 to-brand-900 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-10 w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-brand-700 mb-2">Prodigy Support</h1>
        <p className="text-gray-500 mb-8">מערכת ניהול קריאות IT</p>

        {err && (
          <div className="mb-6 rounded-xl border border-red-200 bg-red-50 px-5 py-4 text-right" dir="rtl">
            <p className="font-semibold text-red-700 mb-1">{err.title}</p>
            <p className="text-sm text-red-600">{err.body}</p>
          </div>
        )}

        {authError === "server_unavailable" && (
          // the session is still stored: a reload re-checks it (the Microsoft button below starts a NEW login)
          <button
            onClick={() => window.location.reload()}
            className="w-full mb-3 border border-brand-600 text-brand-600 hover:bg-brand-50 font-semibold py-3 px-6 rounded-xl transition"
          >
            טען מחדש
          </button>
        )}

        <button
          onClick={login}
          className="w-full flex items-center justify-center gap-3 bg-brand-600 hover:bg-brand-700 text-white font-semibold py-3 px-6 rounded-xl transition"
        >
          <img src="https://learn.microsoft.com/favicon.ico" alt="Microsoft" className="w-5 h-5" />
          {err && authError !== "server_unavailable" ? "נסה שוב עם חשבון אחר" : "התחבר עם Microsoft 365"}
        </button>

        <p className="text-xs text-gray-400 mt-6">Prodigy IT © 2025</p>
      </div>
    </div>
  );
}
